class PremiumSideCart {
  constructor() {
    this.drawer = document.getElementById('PremiumSideCart');
    this.overlay = document.getElementById('PremiumCartOverlay');
    this.isUpdating = false;

    this.init();
    this.listenToAllAdds(); // El Modo Dios activado
  }

  init() {
    // Escuchar botones para abrir
    const openTriggers = document.querySelectorAll('a[href="/cart"], .header__icon--cart, [data-ajax-cart-trigger], .cart-icon, .custom-premium-trigger');
    openTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Delegación de clics internos
    document.addEventListener('click', (e) => {
      if (e.target.closest('#PremiumCartOverlay') || e.target.closest('#PremiumCartClose') || e.target.closest('#PremiumCartContinue')) {
        this.close();
        return;
      }

      const isInsideCart = e.target.closest('#PremiumSideCart');
      if (!isInsideCart) return;

      const qtyBtn = e.target.closest('.ptc-qty-btn');
      if (qtyBtn && !this.isUpdating) {
        e.preventDefault();
        this.updateItem(qtyBtn.getAttribute('data-key'), parseInt(qtyBtn.getAttribute('data-qty')));
        return;
      }

      const removeBtn = e.target.closest('.ptc-remove-btn');
      if (removeBtn && !this.isUpdating) {
        e.preventDefault();
        this.updateItem(removeBtn.getAttribute('data-key'), 0); 
        return;
      }
    });

    // Cambios manuales de input
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('ptc-qty-input') && !this.isUpdating) {
        let qty = parseInt(e.target.value);
        if (isNaN(qty) || qty < 0) qty = 1;
        this.updateItem(e.target.getAttribute('data-key'), qty);
      }
    });

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Enter' && e.target.classList.contains('ptc-qty-input')) e.target.blur(); 
    });
  }

  // EL DOBLE INTERCEPTOR (Atrapa TODO lo que entra al carrito)
  listenToAllAdds() {
    const self = this;

    const originalFetch = window.fetch;
    window.fetch = async function() {
      const response = await originalFetch.apply(this, arguments);
      const url = arguments[0];
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
        response.clone().json().then(() => {
          self.refreshCartHTML();
          self.open();
        }).catch(e => {});
      }
      return response;
    };

    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      this.addEventListener('load', function() {
        if (this._url && (this._url.includes('/cart/add') || this._url.includes('/cart/add.js'))) {
          self.refreshCartHTML();
          self.open();
        }
      });
      origOpen.apply(this, arguments);
    };

    const origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      this._url = arguments[1] ? arguments[1].url : this.responseURL;
      origSend.apply(this, arguments);
    };
  }

  open() {
    this.refreshCartHTML(); 
    if(this.drawer) this.drawer.classList.add('is-open');
    if(this.overlay) this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden'; 
  }

  close() {
    if(this.drawer) this.drawer.classList.remove('is-open');
    if(this.overlay) this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  updateItem(key, quantity) {
    if(this.isUpdating) return;
    this.isUpdating = true; 
    if(this.drawer) this.drawer.classList.add('ptc-is-loading'); 

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'premium-side-cart', sections_url: window.location.pathname })
    })
    .then(response => response.json())
    .then(state => {
      if (state.sections && state.sections['premium-side-cart']) {
        this.injectHTML(state.sections['premium-side-cart']);
      } else {
        this.refreshCartHTML(); 
      }
    })
    .catch(() => {})
    .finally(() => {
       this.isUpdating = false;
       if(this.drawer) this.drawer.classList.remove('ptc-is-loading');
    });
  }

  refreshCartHTML() {
    if(this.isUpdating) return; 
    this.isUpdating = true;
    if(this.drawer) this.drawer.classList.add('ptc-is-loading');

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const url = `${rootUrl}?section_id=premium-side-cart&t=${Date.now()}`;

    fetch(url, { method: 'GET', cache: 'no-store', headers: { 'Pragma': 'no-cache', 'Cache-Control': 'no-cache, no-store, must-revalidate' } })
    .then(response => response.text())
    .then(text => this.injectHTML(text))
    .catch(() => {})
    .finally(() => {
       this.isUpdating = false;
       if(this.drawer) this.drawer.classList.remove('ptc-is-loading');
    });
  }

  injectHTML(htmlString) {
    const html = new DOMParser().parseFromString(htmlString, 'text/html');
    const newInner = html.querySelector('#PremiumSideCartInner');
    const currentInner = document.getElementById('PremiumSideCartInner');
    
    if (newInner && currentInner) {
        // 1. Actualizamos el HTML visual del carrito
        currentInner.innerHTML = newInner.innerHTML;
        
        // 2. Extraemos el número de productos que quedaron (0, 1, 2, etc.)
        const newCount = parseInt(newInner.getAttribute('data-cart-count')) || 0;
        currentInner.setAttribute('data-cart-count', newCount);
        
        // 3. LA SOLUCIÓN: Le disparamos una señal directa al Header con el número exacto
        // Si el número es 0, el Header recibirá la señal y apagará el anillo de luz inmediatamente.
        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: { item_count: newCount } }));
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new PremiumSideCart());